import { render, staticRenderFns } from "./PasswordResetConfirm.vue?vue&type=template&id=9a6545b4&scoped=true&"
import script from "./PasswordResetConfirm.vue?vue&type=script&lang=js&"
export * from "./PasswordResetConfirm.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetConfirm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PasswordResetConfirm.vue?vue&type=style&index=1&id=9a6545b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6545b4",
  null
  
)

export default component.exports